export default __webpack_public_path__ + "locales/ar-SA/PeopleTranslations.json?hash=dfbc9f007fcefd1909aa087f3ac3fa3e";